import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { DeleteScientificCommittee } from "../../../Redux/Reducers/Manager/ScientificCommittee";

const ScientificCommitteeTable = () => {
  const ScientificCommitteeInfoRow = useSelector(
    (state) => state.ScientificCommittee?.ScientificCommitteeInfoRow
  );

  const state = useSelector((state) => {
    return {
      EvaluatorInfoRow: state.EvaluatorInfo.AddEvaluatorInfoRow,
    };
  });
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "roundName",
      ShowStatus: true,
      NmaeColumn: "الدورة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "userFullName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "note",
      ShowStatus: true,
      NmaeColumn: "ملاحظات",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);
        console.log(data, "sdsdsdsdsdsdsds");

        Swal.fire({
          title: "  هل انت متأكد من الحذف ؟",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "إلغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            var result = await dispatch(
              DeleteScientificCommittee({
                eV_ST_ScientificCommitteeInfoId:
                  data.eV_ST_ScientificCommitteeInfoId,
              })
            );
            console.log(result, "result.payload.code");
            if (result.payload.code == 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              dispatch(setRefreshTable({ tableId: "ScientificCommittee" }));
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"eV_ST_ScientificCommitteeInfoId"}
        valueButtonAction={"eV_ST_ScientificCommitteeInfoId"}
        URL={`api/ScientificCommittee/GetScientificCommitteeListByUserId`}
        UrlBody={{
          userGUID: ScientificCommitteeInfoRow?.userGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        tableId="ScientificCommittee"
        accessor={RequestAccessor}
        titelTable={"تعيين العضو"}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};
export default ScientificCommitteeTable;
